import "./components/MarketingGrowth.css";
import { Link } from "react-router-dom";
import positioningIcon from "../../assets/images/marketing/positioning.png";
import growthIcon from "../../assets/images/marketing/growth.png";
import digitalIcon from "../../assets/images/marketing/digital.png";
import mediaIcon from "../../assets/images/marketing/media.png";

const MarketingGrowthPage = () => {
  return (
    <section className="marketing-page">

      {/* HERO */}
      <div className="container marketing-hero">
        <h1>
          Marketing Strategy <br />
          <span className="gold">Backed by Insight</span>
        </h1>

        <p>
          We help businesses sharpen their market positioning, improve communication clarity,
          and make better marketing decisions through structured advisory support.
        </p>
      </div>

      {/* SERVICE BLOCKS */}
      <div className="container marketing-grid">

        <div className="marketing-card">
          <img src={positioningIcon} alt="" />
          <h3>Positioning & Messaging</h3>
          <div className="yellow-line"></div>
          <p>
            Clarify what your brand stands for, who it serves, and how it should communicate.
          </p>
        </div>

        <div className="marketing-card">
          <img src={growthIcon} alt="" />
          <h3>Growth Strategy</h3>
          <div className="yellow-line"></div>
          <p>
            Identify pathways for market entry, expansion, customer acquisition,
            and stronger commercial focus.
          </p>
        </div>

        <div className="marketing-card">
          <img src={digitalIcon} alt="" />
          <h3>Digital Presence</h3>
          <div className="yellow-line"></div>
          <p>
            Develop more effective digital narratives across websites,
            content systems, and external communications.
          </p>
        </div>

        <div className="marketing-card">
          <img src={mediaIcon} alt="" />
          <h3>Media & Communications Advisory</h3>
          <div className="yellow-line"></div>
          <p>
            Support smarter decision-making around media, content direction,
            and public-facing messaging.
          </p>
        </div>

      </div>

      {/* BOTTOM CTA STRIP */}
      <div className="container marketing-cta">
        <div className="cta-box">
          <p>
            Helping brands grow with <span className="gold">clarity</span>,
            <span className="gold"> strategy</span>, and
            <span className="gold"> measurable impact</span>.
          </p>

          <Link to="/contact" className="cta-btn">
            Let’s Build Your Growth Roadmap
          </Link>
        </div>
      </div>

    </section>
  );
};

export default MarketingGrowthPage;